import { render, staticRenderFns } from "./factories_batches.vue?vue&type=template&id=56ecfa62&scoped=true&"
import script from "./factories_batches.vue?vue&type=script&lang=js&"
export * from "./factories_batches.vue?vue&type=script&lang=js&"
import style0 from "./factories_batches.vue?vue&type=style&index=0&id=56ecfa62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ecfa62",
  null
  
)

export default component.exports